import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { usePaymentStore } from '@/store/modules/payment';
import { useKycStore } from '@/store/modules/kyc';
import { Input, WidgetDropDownSingleValue, Button, CountrySelectList, } from '@yellowcard/components-library-vue3';
import { CountryTypes } from '@/types/country';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import { KycTypes } from '@/types/kyc';
import { PaymentTypes } from '@/types/payment';
import router from '@/router';
import validator from 'validator';
import { storeToRefs } from 'pinia';
import { validateMobileNumber } from '@/utils/helpers';
import LoaderComponent from '../general/LoaderComponent.vue';
export default defineComponent({
    name: 'MobileMoneyDetails',
    components: {
        Input,
        WidgetDropDownSingleValue,
        TransactHeader,
        Button,
        CountrySelectList,
        LoaderComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedChannel, loading, countryConfig, loadingMessage, activeSupportedCountryConfig, channel, } = storeToRefs(transactionsStore);
        const paymentStore = usePaymentStore();
        const { selectedPaymentNetwork, userMomoAccountNumber, paymentNetworks, currentStep: paymentCurrentStep, } = storeToRefs(paymentStore);
        const kycStore = useKycStore();
        const { kycStatus } = storeToRefs(kycStore);
        const error = ref(undefined);
        const countryCodeOptions = [
            {
                value: countryConfig.value.countryCode,
                label: countryConfig.value.countryCode,
                country: countryConfig.value.country,
            },
        ];
        const defaultCountry = computed(() => countryCodeOptions[0]);
        const mobileNetworkNames = ref(['']);
        const creatingOrder = ref(false);
        const isInvalidPhoneNumber = ref(false);
        const validatePhoneNumber = (value) => {
            if (validator.isEmpty(value))
                return ' ';
            return validateMobileNumber(value, activeSupportedCountryConfig.value?.phoneValidation.MIN_PHONE_LENGTH, activeSupportedCountryConfig.value?.phoneValidation.MAX_PHONE_LENGTH);
        };
        const buttonDisabled = computed(() => creatingOrder.value ||
            !userMomoAccountNumber.value ||
            !selectedPaymentNetwork.value ||
            isInvalidPhoneNumber.value);
        watch(userMomoAccountNumber, newNumber => {
            isInvalidPhoneNumber.value = validatePhoneNumber(newNumber) !== true;
        });
        onMounted(async () => {
            try {
                loading.value = true;
                loadingMessage.value = 'Fetching providers';
                if (selectedChannel.value && channel.value) {
                    await paymentStore.getNetworks({
                        country: countryConfig.value.country,
                        accountType: 'phone',
                        channelId: channel.value.id,
                    });
                    paymentNetworks.value.sort((netA, netB) => netA.name > netB.name ? 1 : -1);
                    mobileNetworkNames.value = paymentNetworks.value.map(network => network.name);
                }
                loading.value = false;
                loadingMessage.value = '';
            }
            catch (e) {
                loading.value = false;
                loadingMessage.value = '';
            }
        });
        const goBack = () => {
            paymentCurrentStep.value = PaymentTypes.PaymentSteps.PAYMENT_1;
        };
        const onNetworkSelected = (evt) => {
            selectedPaymentNetwork.value =
                paymentNetworks.value.find(network => network.name === evt) ?? null;
        };
        const submitDepositOrder = async () => {
            try {
                error.value = undefined;
                loadingMessage.value = 'Sending your deposit request';
                loading.value = true;
                creatingOrder.value = true;
                await transactionsStore.createOrder({});
                loadingMessage.value = '';
                loading.value = false;
                creatingOrder.value = false;
                if (kycStatus.value !== KycTypes.KycStatus.APPROVED) {
                    paymentCurrentStep.value = PaymentTypes.PaymentSteps.PAYMENT_1;
                    await router.push('/kyc');
                }
                else {
                    paymentCurrentStep.value = PaymentTypes.PaymentSteps.PAYMENT_4;
                }
            }
            catch (e) {
                loadingMessage.value = '';
                loading.value = false;
                creatingOrder.value = false;
                console.error('Failed to create order');
                error.value = 'Failed to create order';
            }
        };
        return {
            userMomoAccountNumber,
            CountryTypes,
            submitDepositOrder,
            mobileNetworkNames,
            onNetworkSelected,
            selectedPaymentNetwork,
            countryCodeOptions,
            loading,
            buttonDisabled,
            defaultCountry,
            goBack,
            validatePhoneNumber,
            error,
        };
    },
});
